// extracted by mini-css-extract-plugin
export default {"paragraphWrapper":"style_paragraphWrapper__CmbmZ","paragraph":"style_paragraph__q0GZm","word":"style_word__XeaVG"};